
 <v-container class="step-container" v-if="unit && current">
     <c-drop-message
         v-if     = "drag.notAllowed"
         :message ="drag.message"
     />

     <d-attach-confirm
         v-model = "attach.visible"
         :data   = "attach.data"
         @attach = "onAttach"
         @cancel = "onAttachCancel"
     />

     <drop @drop="onDrop" mode="cut" :accepts-type="onAcceptType">
         <v-row class="no-frame" :key="refreshAll">
             <v-col class="step-first-column" style="padding-bottom: 0">
                 <inc-site-down-switch v-model="current.unitDown" v-if="!scheduled" />

                 <f-title :title="'Ereignis'" style="margin-bottom: 12px; margin-top: 4px" v-if="!scheduled" />

                 <v-row class="no-frame">
                     <f-enum-select
                         v-model   = "data.company"
                         :label    = "$t('inc.assessment.company')"
                         :readonly = "readonly"
                         :rules    = "[requiredRule]"
                         module    = "inc"
                         type      = "zuescompanies"
                         :background = "fileEntryFieldBackground"
                     />
                 </v-row>

                 <v-row class="no-frame" v-if="scheduled">
                     <f-enum-select
                         v-model   = "current.type"
                         :label    = "$t('inc.assessment.type')"
                         :readonly = "readonly"
                         :rules    = "[requiredRule]"
                         module    = "inc"
                         type      = "assessmenttypes"
                     />
                 </v-row>

                 <v-row class="no-frame" v-if="scheduled">
                     <div style="height: 50px"></div>
                 </v-row>

                 <inc-status
                     v-model = "current.status"
                     :items  = "step.status"
                     @change = "onStatusChanged"


                 />
                 <msd-users
                     v-model="incident.responsible"
                     :background = "fileEntryFieldBackground"
                 />

                 <v-row class="no-frame" v-if="!scheduled">
                     <v-col class="pa-0 pr-2">
                         <v-text-field
                             :label         = "$t('inc.edit.general.reporter')"
                             v-model        = "data.reporter"
                             autocomplete   = "off"
                             autocorrect    = "off"
                             autocapitalize = "off"
                             spellcheck     = "false"
                         />
                     </v-col>
                 </v-row>

                 <v-row class="no-frame" v-if="scheduled">
                     <div style="height: 50px"></div>
                 </v-row>

                 <v-row class="no-frame" v-if = "scheduled">
                     <v-col class="pa-0 pr-2">
                         <f-date-picker
                             v-model   = "current.dateAssessment"
                             label     = "inb.detail.assessment.date"
                             :readonly = "readonly"
                             :rules    = "[requiredRule]"
                             class     = "w-100"
                         />

                         <!--
                         <f-date-picker
                             :label    = "scheduled ? 'inc.assessment.date' : 'inc.edit.common.processing.start'"
                             :time     = "false"
                             v-model   = "current.beginDate"
                             :required = "true"
                             :rules    = "[requiredRule]"
                             class     = "mr-2 w-100"
                             @change   = "onScheduleChanged"
                         />
                     -->
                     </v-col>
                     <v-col class="pa-0 pr-2">
                     </v-col>
                 </v-row>

                 <inc-unit-down-interval
                     v-if      = "!scheduled"
                     :unitdata     = "current"
                     :status       = "current.status"
                 />

                 <c-v-spacer />
             </v-col>
             <v-col class="step-middle-column">
                 <div v-if="!scheduled">
                     <v-row class="no-frame" >
                         <v-col class="pa-0" >
                             <v-switch
                                 v-if="!current.invoiceId"
                                 v-model = "data.invoice"
                                 :label  = "$t('inc.edit.common.invoice')"
                                 @change = "onInvoice"
                                 class   = "pt-0 mt-0"
                                 hide-details
                             />
                             <div v-if="current.invoiceId" class="v-flex">
                                 <c-toolbar-button

                                     class="mt-n1"
                                     icon="mdi-arrow-left-thin-circle-outline"
                                     color="primary"
                                     size="22"
                                     tooltip="Zur ZÜS Rechnung wechseln"
                                     @click="onGotoInvoice"
                                 />
                                 <div style="margin-top: -1px" class="primary--text">
                                     zur Rechnung
                                 </div>

                             </div>
                         </v-col>
                     </v-row>

                     <f-title :title="$t ('inb.detail.assessment.title.main')" style="margin-top: 10px" />
                     <v-row class="no-frame mt-3">
                         <f-enum-select
                             v-model   = "current.type"
                             :label    = "$t('inc.assessment.type')"
                             :readonly = "readonly"
                             :rules    = "[ requiredRule ]"
                             module    = "inc"
                             type      = "assessmenttypes"
                         />
                     </v-row>

                     <v-row class="no-frame">
                         <v-col class="pa-0 pr-2">
                             <f-enum-select
                                 v-model   = "current.result"
                                 :label    = "$t('inc.assessment.result')"
                                 :readonly = "readonly"
                                 :rules    = "[ requiredAfterExecution ]"
                                 module    = "inc"
                                 type      = "assessmentresults"
                                 @input    = "validate"
                             />
                         </v-col>
                         <v-col class="pa-0 pl-2">
                             <f-date-picker
                                 v-model   = "current.dateAssessment"
                                 label     = "inb.detail.assessment.date"
                                 :readonly = "readonly"
                                 :rules    = "[ requiredAfterExecution ]"
                                 class     = "w-100"
                                 @change   = "onAssessmentDate"
                             />
                         </v-col>
                     </v-row>

                     <v-row class="no-frame">
                         <v-col class="pa-0 pr-2">
                             <div class="v-flex" v-if="nextDateRequired">
                                 <f-date-picker
                                     v-model = "current.dateNextAssessment"
                                     :rules  = "[ requiredAfterExecution, nextDateLessThanDateRemedyOfDefects ]"
                                     label   = "inb.detail.assessment.dateNext"
                                     class   = "w-100"
                                 />

                                 <v-btn
                                     v-if   = "current.nextAssessment"
                                     color  = "primary"
                                     @click = "onGoto (data.nextAssessment.id)"
                                     class  = "mt-3 ml-2"
                                     x-small
                                     fab
                                     depressed
                                     outlined
                                 >
                                     <i class="fas fa-chevron-right white--text"></i>
                                 </v-btn>
                             </div>
                         </v-col>
                         <v-col class="pa-0 pl-2">
                             <div class="v-flex">
                                 <f-date-picker
                                     v-model = "current.dateRemedyOfDefects"
                                     label   = "inb.detail.assessment.dateRemedy"
                                     :rules  = "[ requiredOnDefects, dateRemedyOfDefectsGreaterThanNextDate ]"
                                     class   = "w-100"
                                 />

                                 <v-btn
                                     v-if   = "current.nextReview"
                                     color  = "primary"
                                     @click = "onGoto (data.nextReview.id)"
                                     class  = "mt-3 ml-2"
                                     fab
                                     depressed
                                     outlined
                                     x-small
                                 >
                                     <i class="fas fa-chevron-right white--text"></i>
                                 </v-btn>
                             </div>
                         </v-col>
                     </v-row>

                     <f-title :title="$t('inb.detail.assessment.title.contact')" style="margin-top: 20px"/>

                     <v-row class="no-frame mt-5" >
                         <v-col class="pa-0 pr-2">
                             <v-text-field
                                 v-model = "current.contactName"
                                 :label  = "$t('inb.detail.assessment.contact.name')"
                                 autocomplete   = "off"
                                 autocorrect    = "off"
                                 autocapitalize = "off"
                                 spellcheck     = "false"
                             />
                         </v-col>
                     </v-row>
                     <v-row class="no-frame">
                         <v-col class="pa-0 pr-2">
                             <v-text-field
                                 v-model = "current.contactPhone"
                                 :label  = "$t('inb.detail.assessment.contact.phone')"
                                 autocomplete   = "off"
                                 autocorrect    = "off"
                                 autocapitalize = "off"
                                 spellcheck     = "false"
                             />
                         </v-col>
                         <v-col class="pa-0 pl-2">
                             <v-text-field
                                 v-model = "current.contactMobile"
                                 :label  = "$t('inb.detail.assessment.contact.mobile')"
                                 autocomplete   = "off"
                                 autocorrect    = "off"
                                 autocapitalize = "off"
                                 spellcheck     = "false"
                             />
                         </v-col>
                     </v-row>
                     <v-row class="no-frame">
                         <v-col class="pa-0 pr-2">
                             <v-text-field
                                 v-model = "current.contactMail"
                                 :label  = "$t('inb.detail.assessment.contact.mail')"
                                 autocomplete   = "off"
                                 autocorrect    = "off"
                                 autocapitalize = "off"
                                 spellcheck     = "false"
                             />
                         </v-col>
                     </v-row>
                 </div>
             </v-col>

             <v-col class="step-middle-column" style="padding-right: 5px">
                 <div v-if="!scheduled" style="height: 100%">
                     <f-title :title="$t('inb.detail.assessment.title.defects')" style="margin-top: 34px; margin-right: 12px" />
                     <inc-assessment-faults
                         :faults = "current.faults"
                         :result = "current.result"
                         :height = "540"
                         @change = "onFaults"
                     />
                 </div>
             </v-col>

             <v-col class="step-last-column">
                 <crm-journal
                     :incident = "incident"
                     @front   ="onJournalFront"
                     style="margin-top: -5px" />
             </v-col>
         </v-row>
     </drop>
</v-container>
